import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import api from '../utils/api';

const Login = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const setAuth = useAuthStore((state) => state.setAuth);
    const [loading, setLoading] = React.useState(false);

    const onFinish = async (values) => {
        try {
            setLoading(true);
            const response = await api.post('/auth/login', values);
            const { token, user } = response.data;

            // Set auth state
            setAuth(user, token);

            // Ensure localStorage is written before navigation
            // This is critical for mobile browsers
            await new Promise(resolve => setTimeout(resolve, 100));

            // Verify the token was saved
            const savedToken = localStorage.getItem('token');
            if (!savedToken) {
                console.error('Token not saved to localStorage');
                message.error(t('loginFailed'));
                return;
            }

            // Set user's preferred language
            if (user.language) {
                i18n.changeLanguage(user.language);
                document.documentElement.dir = user.language === 'en' ? 'ltr' : 'rtl';
                document.documentElement.lang = user.language;
            }

            message.success(t('loginSuccessful'));

            // Use replace instead of push to prevent back navigation to login
            // Redirect based on role
            if (user.role === 'dataentry') {
                navigate('/students', { replace: true });
            } else {
                navigate('/dashboard', { replace: true });
            }
        } catch (error) {
            message.error(error.response?.data?.message || t('loginFailed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <Card className="login-box">
                <h1 className="login-title">{t('paymanga')}</h1>
                <p style={{ textAlign: 'center', marginBottom: 24, color: '#666' }}>
                    {t('languageInstituteManagementSystem')}
                </p>

                <Form name="login" onFinish={onFinish} size="large">
                    <Form.Item
                        name="email"
                        rules={[
                            { required: true, message: t('pleaseInputEmail') },
                            { type: 'email', message: t('pleaseEnterValidEmail') },
                        ]}
                    >
                        <Input prefix={<UserOutlined />} placeholder={t('email')} />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: t('pleaseInputPassword') }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder={t('password')} />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} block>
                            {t('login')}
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default Login;
